import axios from 'axios'

export default class ParametrosGerais {
  constructor(tokenBearer, url) {
    this.url = `${url}/api/parametros`
    this.tokenBearer = tokenBearer
  }

  getParametroSimples(codigo) {
    return new Promise(async (resolve, reject) => {
      let optionsParametrosSimples = {
        method: 'get',
        url: `${this.url}/simples/${codigo}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseParametros = await axios(optionsParametrosSimples)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  putParametroSimples(data) {
    return new Promise(async (resolve, reject) => {
      let optionsParametrosSimples = {
        method: 'put',
        url: `${this.url}/simples`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseParametros = await axios(optionsParametrosSimples)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  postParametroSimples(data) {
    return new Promise(async (resolve, reject) => {
      let optionsParametrosSimples = {
        method: 'post',
        url: `${this.url}/tipoSelo`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseParametros = await axios(optionsParametrosSimples)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAllTipoSelo() {
    return new Promise(async (resolve, reject) => {
      let optionsParametroSelo = {
        method: 'get',
        url: `${this.url}/tipoSelo/`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseParametros = await axios(optionsParametroSelo)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  putParametroSelo(data, ativo, bloqueado, descricao, id, ordem) {
    return new Promise(async (resolve, reject) => {
      let optionsParametroSelo = {
        method: 'put',
        url: `${this.url}/tipoSelo/`,
        headers: {
          Authorization: this.tokenBearer
        },
        data,
        params: { ativo, bloqueado, descricao, id, ordem }
      }

      try {
        let responseParametros = await axios(optionsParametroSelo)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTipoSelo(tipoSeloId) {
    return new Promise(async (resolve, reject) => {
      let optionsParametroSelo = {
        method: 'get',
        url: `${this.url}/tipoSelo/${tipoSeloId}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseParametros = await axios(optionsParametroSelo)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAllIniciativasInstitucionais() {
    return new Promise(async (resolve, reject) => {
      let optionsParametroSelo = {
        method: 'get',
        url: `${this.url}/iniciativaInstitucional`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseParametros = await axios(optionsParametroSelo)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  putIniciativaInstitucional(data, nome, descricao, id, ordem) {
    return new Promise(async (resolve, reject) => {
      let optionsParametroSelo = {
        method: 'put',
        url: `${this.url}/iniciativaInstitucional/`,
        headers: {
          Authorization: this.tokenBearer
        },
        data,
        params: {
          id,
          nome,
          descricao,
          ordem
        }
      }

      try {
        let responseParametros = await axios(optionsParametroSelo)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteIniciativaInstitucional(data) {
    return new Promise(async (resolve, reject) => {
      const options = {
        method: 'delete',
        url: `${this.url}/iniciativaInstitucional`,
        headers: { Authorization: this.tokenBearer },
        data
      }

      try {
        const responseParametros = await axios(options)
        resolve(responseParametros)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getParametrosNotificacao() {
    let optionsParametroNotificacao = {
      method: 'get',
      url: `${this.url}/notificacao`,
      headers: { Authorization: this.tokenBearer }
    }

    return await axios(optionsParametroNotificacao)
  }

  async putParametroNotificacao(id, data) {
    let optionsParametroNotificacao = {
      method: 'put',
      url: `${this.url}/notificacao/${id}`,
      headers: { Authorization: this.tokenBearer },
      data
    }

    return await axios(optionsParametroNotificacao)
  }
}
